import { Component, OnInit, Inject, Optional, ViewChild } from '@angular/core';
import { MatTableDataSource, MatDialogRef, MAT_DIALOG_DATA, MatSort } from '@angular/material';
import { Candidate } from 'src/app/model/candidate.model';
import { SelectionModel } from '@angular/cdk/collections';
import { PanelAsignService } from 'src/app/shared/panel-assign/panel-assign.service';
import { PanelService } from 'src/app/shared/panel-service/panel.service';
import { ProcessService } from 'src/app/shared/process-service/process.service';

export interface DialogData {
  selectedCandidatePerPanel: string[];
  processId: number;
  onEditPanel: number;
}

@Component({
  selector: 'app-candidate-list-modal',
  templateUrl: './candidate-list-modal.component.html',
  styleUrls: ['./candidate-list-modal.component.scss']
})
export class CandidateListModalComponent implements OnInit {

  filterName: string;
  candidateList = [];
  listData: MatTableDataSource<any>;
  private candidates: Candidate[];
  private candidateSelectedList = [];
  private processId: number;
  private onEditPanel: number;
  assignedCandidateListData = [];                                                       //, 'contactNo'

  displayedColumns: string[] = ['position', 'select', 'candidateName', 'assignStatus', 'email', 'gender', 'address', 'totalMarks', 'score'];

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private panelService: PanelService,
    private panelAsignService: PanelAsignService,
    private processService: ProcessService,
    public dialogRef: MatDialogRef<CandidateListModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public element: DialogData
  ) {
    element.selectedCandidatePerPanel = this.candidateSelectedList;
    this.processId = element.processId;
    this.onEditPanel = element.onEditPanel;
  }

  //for Check Box Selection in a table
  selection = new SelectionModel<any>(true, []);

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    if (this.listData != null) {
      const numSelected = this.selection.selected.length;
      const numRows = this.listData.data.length;
      return numSelected === numRows;
    }
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.listData.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  ngOnInit() {
    if (this.onEditPanel != 0) {
      this.availableCandidateForReAssignment();
    } else {
      this.getAvailableCandidates();
    }
  }
  getAllAssignedPanel() {
    this.listData.data.forEach(row => {
      if ((this.assignedCandidateListData.indexOf(row.candidateId)) > -1) {
        this.selection.select(row);
      }
      if (row.panelCandidates.length > 0) {
        if (row.panelCandidates[0].panelId === this.onEditPanel) {
          this.selection.select(row);
        }
      }
    }
    );

  }
  getAvailableCandidates() {
    this.panelService.availableCandidate(this.processId).then(
      candidates => {
        this.candidates = candidates;
        if (this.candidates.length != 0) {
          this.listData = new MatTableDataSource(candidates);
          this.listData.sort = this.sort;
          this.getAllAssignedPanel();
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  availableCandidateForReAssignment() {
    this.processService.availableCandidateForReAssignment(this.onEditPanel).then(
      candidates => {
        this.candidates = candidates;
        this.listData = new MatTableDataSource(candidates);
        this.listData.sort = this.sort;
        //this.shortListedMap.set(processId, candidates.length);
        this.getAllAssignedPanel();
      },
      err => {
        console.log(err);
      }
    );
  }

  applyFilter(filterValue: string) {
    this.listData.filter = filterValue.trim().toLowerCase();
  }
  onClear() {
    this.listData.filter = '';
    this.filterName = '';
  }

  onClose() {
    this.dialogRef.close();
  }

  candidateChanged() {
    console.log(this.selection.selected);
    this.candidateSelectedList.push(this.selection.selected);
  }

  getCandidateIdForRow(panelCandidate: any) {
    if (panelCandidate) {
      return panelCandidate.candidateId;
    } else {
      return "";
    }
  }
}

